import { ICustomer } from '@/api/services/CustomerService';
import { openDB } from 'idb';
import { initializeUser, clearUserId } from '@/store/userStore';

const DB_NAME = 'UserDB';
const STORE_NAME = 'user';
const DB_VERSION = 1;
const USER_KEY = 'currentUser';

export const initDB = async () => {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

// Set or update the specific user
export const setCurrentUser = async (user: ICustomer) => {
  const db = await initDB();
   await initializeUser(user);
  return db.put(STORE_NAME, user, USER_KEY);
};

// Get the current user
export const getCurrentUser = async () => {
  const db = await initDB();
  return db.get(STORE_NAME, USER_KEY);
};

// Delete the current user from all three stores: IndexedDB, userStore module var, and Zustand (caller's responsibility)
export const clearCurrentUser = async () => {
  const db = await initDB();
  clearUserId();
  return db.delete(STORE_NAME, USER_KEY);
};
